import React from 'react';

import Typography from '@mui/material/Typography';
import { RenderElementProps } from 'slate-react';

export const DefaultElement: React.FC<RenderElementProps> = ({ attributes, children }) => {
  return (
    <Typography component="span" variant="body2" {...attributes}>
      {children}
    </Typography>
  );
};
